module.exports = __webpack_public_path__ + "be5f3a5db85aa84032997be4ae19a466.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-11-20/whats-new.html
// module id = 2241
// module chunks = 0